import Vue from "vue";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
import "@/assets/scss/vendors-extensions/bootstrap/custom.scss";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
